import $ from "jquery";
import { tableResponsive } from "#scripts/table";
import { setImages } from "#scripts/images";
import {
	checkNested,
	setVariable,
	adjustVariables,
	urlParseCheck,
	checkDocument,
} from "#scripts/general_functions";
import { compileResources } from "#scripts/compile";
import { messagefromSystem } from "#scripts/dialog/dialog_messages";
import { setAccordian } from "#scripts/accordian";

export const getAimData = (id) => {
	if (!id) {
		return;
	}
	const apiCall = `${window.apiUrl}/PublicContentApi/find/${id}`;
	$.when(
		$.getJSON(apiCall),
		$.ajax({
			type: "POST",
			url: "https://kariadmin.azurewebsites.net/api/clientvariables",
			contentType: "application/json-patch+json",
			data: JSON.stringify({
				clientId: window.serverdata.configMeta.aim.servioId,
			}),
		}),
	)
		.fail(() => 404)
		.done((article, _variables) => {
			// const allVariable = [...karivars[0], ...karilinks[0]];

			const variables = adjustVariables(_variables[0]);

			const allVariable = variables;

			if (checkNested(article[0], "pageTypeId")) {
				if (article[0].pageTypeId === "mal_artikkel") {
					parent.location = `/artikkel/${id}`;
					return;
				}
			} else {
				parent.location = "/404";
			}

			const removeExtraSpace = (_content) => {
				const regex = /<p>&nbsp;<\/p>|<p>/gi;
				const content = _content.replace(regex, "");
				return content;
			};

			let content = decodeURIComponent(article[0].contentObject);
			// let content = article[0].contentObject;

			const me = $(`<div>${content}</div>`);
			me.find(".var_text").contents().unwrap();
			content = me.html();

			const allRelateds = [];

			const pushRelatedContentObjects = (obj) => {
				if (obj.relatedContentObjects) {
					for (const relObj of obj.relatedContentObjects) {
						allRelateds.push(relObj);
						if (relObj.relatedContentObjects) {
							pushRelatedContentObjects(relObj);
						}
					}
				}
			};

			pushRelatedContentObjects(article[0]);

			content = compileResources(content, article[0].relatedContentObjects);

			content = removeExtraSpace(content);

			content = tableResponsive(content).innerHTML;

			content = setImages(content);

			content = setVariable(content, allVariable);

			content = setAccordian(content);

			content = urlParseCheck(content);

			content = checkDocument(content, allRelateds);

			if (article[0].pageTypeId === "mal_blokk") {
				messagefromSystem(content);
			} else {
				window.location.href = `/artikkel/${id}`;
			}

			$(".removewhendone").remove();

			// createGallery();
		});
};
